module.exports = ":host .discount-item {\n  background-color: #f9f9f9;\n  border: 1px solid #dddddd;\n  padding: 17px 15px 20px; }\n\n:host .delete-container {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -webkit-justify-content: flex-end;\n      -ms-flex-pack: end;\n          justify-content: flex-end; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.scss
// module id = ./web/modern/components/quotes/common/discount-create-block/discount-create-block.component.scss
// module chunks = 0